"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBarWrapper = exports.RightContent = exports.PageHeaderWrapper = exports.PAGE_HEADER_HEIGHT = exports.Nav = exports.MenuNavItem = exports.MenuDropdownContainer = exports.LeftContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _NavItem = require("../NavItem/NavItem.styles");
var _excluded = ["className", "fixed"],
  _excluded2 = ["className", "fixed"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "pageHeaderWrapper": "_7L30Fc",
  "pageHeaderWrapperFixed": "_0H1seg",
  "nav": "WkaawR",
  "navFixed": "VcUHiW",
  "leftContent": "OnalVH",
  "rightContent": "NQAZnT",
  "menuDropdownContainer": "Y2pRnS",
  "searchBarWrapper": "_0lw419"
};
var PAGE_HEADER_HEIGHT = exports.PAGE_HEADER_HEIGHT = '96px';
var PageHeaderWrapper = exports.PageHeaderWrapper = function PageHeaderWrapper(_ref) {
  var className = _ref.className,
    fixed = _ref.fixed,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.pageHeaderWrapper, fixed && styles.pageHeaderWrapperFixed)
  }));
};
var Nav = exports.Nav = function Nav(_ref2) {
  var className = _ref2.className,
    fixed = _ref2.fixed,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("nav", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.nav, fixed && styles.navFixed)
  }));
};
var MenuNavItem = exports.MenuNavItem = function MenuNavItem(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, _extends({}, props, {
    className: (0, _clsx["default"])(className, 'cozy__menu__navItem')
  }));
};
var LeftContent = exports.LeftContent = function LeftContent(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.leftContent)
  }));
};
var RightContent = exports.RightContent = function RightContent(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.rightContent)
  }));
};
var MenuDropdownContainer = exports.MenuDropdownContainer = function MenuDropdownContainer(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.menuDropdownContainer)
  }));
};
var SearchBarWrapper = exports.SearchBarWrapper = function SearchBarWrapper(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.searchBarWrapper)
  }));
};